<div class="zint-base-card bg-white p-3 h-100">
    @if (label){
        <h6 class="text-all-caps text-grey-600 font-size-0-8 mb-3 border-bottom pb-2">{{label}}</h6>
    }
    <div class="d-flex flex-column">
        @if(numeratorLabel || denominatorLabel){
            <div class="d-flex justify-content-between align-items-center font-size-0-8">
                <span class="text-grey-500">{{ numeratorLabel }}</span>
                <span class="text-grey-500">{{ denominatorLabel }}</span>
            </div>
        }

        <mat-progress-bar
            mode="determinate"
            [value]="getProgressBarValue(usage, quota)"
            class="my-2 rounded-sm overflow-hidden"
            [style.--mat-progress-bar-track-color]="progressBarColour"
            style="height: 6px;">
        </mat-progress-bar>

        <div class="d-flex justify-content-between align-items-center">
            <h5 class="mb-0 text-bold-600 font-size-1">{{usage | number}}</h5>
            <h5 class="mb-0 text-bold-600 font-size-1">{{quota | number}}</h5>
        </div>
    </div>
</div>
